import appGlobalScript from '/root/components-marketing/packages/dlt-marketing-components/src/index.ts';
export const globalScripts = appGlobalScript;
